import * as React from 'react';

interface IDeclinesAndReferralsProps {
  declines: IDeclineOrReferrralReason[];
  referrals: IDeclineOrReferrralReason[];
  errors: string[];
  quoteReference?: string;
  renewal: boolean;
}

interface IDeclineOrReferrralReason {
  name: string;
  reason: string;
  team_factor: any;
}

class DeclinesAndReferrals extends React.Component<IDeclinesAndReferralsProps> {
  private getDeclineMessage(field: string) {
    switch (field) {
      case 'revenue':
      case 'activities.real_estate.amount':
        return (
          <span>
            Le chiffre d'affaires renseigné ne permet pas la réalisation d'un devis en ligne. Merci de nous contacter
            à l'adresse suivante : <a href="mailto:rcpro.france@msamlin.com">rcpro.france@msamlin.com</a>
            et nous reviendrons vers vous dans les meilleurs délais
          </span>
        );
      case 'iobsp.declaration.4':
        return (
          <span>
            Nous ne sommes pas en mesure de délivrer une garantie financière avec encaissement de fonds.
          </span>
        );
      case 'declaration.2':
        return (
          <span>
            Vous êtes déjà assuré chez MS AMLIN. Vous pouvez prendre contact directement soit avec votre interlocuteur
            habituel soit nous écrire àl’adresse suivante : <a href="mailto:rcpro.france@msamlin.com">
            rcpro.france@msamlin.com</a>
          </span>
        );

      case 'ias.payments_adjusted':
        return (
          <span>
            Over payment limit
          </span>
        );

      case 'activities.declaration.1':
        return (
          <span>
            Nous ne souhaitons pas garantir cette activité.
          </span>
        );
    }

    return '';
  }

  public render() {
    const { declines, referrals, errors, quoteReference, renewal } = this.props;

    if (! declines.length && ! referrals.length && ! errors.length) {
      return null;
    }

    const declineMessages = Array.from(
      new Set(declines.map((referral) => {
        return this.getDeclineMessage(referral.name);
      })),
    );

    return (
      <div>
        {declines.length > 0 && (
          <div className="alert alert-danger animated fadeIn">
            <ul>
            {declineMessages.map((message, index) => {
              return (
                <li key={index}>{message}</li>
              );
            })}
            </ul>
          </div>

        )}

        {(declines.length === 0 && referrals.length > 0) && (
          <div className="alert alert-warning animated fadeIn">
            {renewal ? (
              <p>
                Nous ne sommes pas en mesure d’entériner votre renouvellement en ligne et reviendrons vers vous dans
                les meilleurs délais. N’hésitez pas à nous contacter par e-mail à l’adresse
                suivante : <a href="mailto:e-rcpro@msamlin.com">e-rcpro@msamlin.com</a>.
              </p>
            ) : (
              <p>
                Compte tenu des réponses apportées, nous ne sommes pas en mesure d’effectuer une cotation en ligne.
                N’hésitez pas à nous contacter par e-mail à l’adresse
                suivante : <a href="mailto:e-rcpro@msamlin.com">e-rcpro@msamlin.com</a>.
                Nous reviendrons vers vous dans les meilleurs délais afin d’étudier ensemble une solution personnalisée.
                <br/><br/>
                Votre référence de devis est <strong>{quoteReference}</strong>.
              </p>
            )}
          </div>
        )}

        {errors.length > 0 && (
          <div className="alert alert-danger animated fadeIn">
            <ul>
              {errors.map((error, index) => {
                return (
                  <li key={index}>{error}</li>
                );
              })}
            </ul>
          </div>
        )}

      </div>
    );
  }
}

export default DeclinesAndReferrals;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/DeclinesAndReferrals/index.tsx